<template>
  <span class="skeleton__text skeleton__text--top-text"></span>
</template>
>
